import AllocatorDetailsModalContainer from './AllocatorDetailsModalContainer'

export default AllocatorDetailsModalContainer
